<template>
  <MainLayout>
    <div
      style="
        height: 100%;
        background-color: white;
        position: fixed;
        width: 100%;
        left: 0;
        top: 0;
        padding-left: var(--sidebar-width);
        padding-top: var(--nav-height);
      "
    >
      <div id="iframe-container"></div>
      <iframe
        sandbox="allow-popups allow-forms allow-same-origin allow-scripts allow-top-navigation allow-top-navigation-by-user-activation allow-downloads"
        allowfullscreen="true"
        style="display: block; height: 100%; overflow: auto; width: 100%; border: none"
        :src="linkIframe"
      ></iframe>
    </div>
  </MainLayout>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AllInOneChat',
  components: {},
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['selectedBot']),
    linkIframe() {
      const url = new URL('https://cms.enterprise.zwiz.app/th/all-in-one-chat-iframe')
      const query = { ...this.$route.query }
      if (query.inbox) {
        url.searchParams.append('inbox', query.inbox)
      }
      if (query.search || query.app) {
        url.searchParams.append(
          'query',
          JSON.stringify({
            search: query.search,
            app: query.app
          })
        )
      }
      return url.href
    }
  },
  mounted() {
    window.addEventListener('message', this.handleMessage)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleMessage)
  },
  methods: {
    handleMessage(event) {
      if (event.data.event_id === 'session_expired') {
        let url = ''
        if (this.currentLang === 'en') {
          url = '/en/nigol'
        } else {
          url = '/th/nigol'
        }
        window.location.href = url
      } else if (event.data.event_id === 'open_external_link') {
        window.open(event.data.url, '_blank')
      } else if (event.data.event_id === 'copy_to_clipboard') {
        if (event.data.value) navigator.clipboard.writeText(event.data.value)
      } else if (event.data.event_id === 'open_link') {
        window.open(event.data.url, '_self')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/AllInOneChat/AllInOneChat.vue